import Icon from './Icon';
import MonasteryImage from './MonasteryImage';

/**
 * The "For monasteries" section's product preview — an actual verified
 * profile from the catalogue (Thrangu Tashi Yangtse, GOMPA's own
 * seed/reference monastery), not an invented mockup with made-up stats. The
 * offering count is the same field `MonasteryCard` renders everywhere else
 * on the site, read from the same source.
 *
 * Deliberately just the card content — no drawn phone bezel, notch, or
 * status bar. The floating tilt and shadow do the "this is a preview" job
 * without fabricating chrome the reader's own device already provides.
 */
const PROFILE = {
  id: 'preview-thrangu-tashi-yangtse',
  name: 'Thrangu Tashi Yangtse Monastery',
  tibetanName: 'ཐྲང་མོ་ལུས་སྤྲུས་ལུས་སྤྱིན།',
  traditionLabel: 'Karma Kagyu',
  badge: 'Namo Buddha Pilgrimage Site',
  location: 'Namo Buddha, Nepal',
  offeringCount: 640,
  photo: {
    source: '/media/monasteries/thrangu-01.webp',
  },
};

export default function MonasteryProfileMockup() {
  return (
    <div className="profile-mockup" aria-hidden="true">
      <div className="profile-mockup__photo-wrap">
        <MonasteryImage photo={PROFILE.photo} monastery={PROFILE} variant="card" className="profile-mockup__photo" />
      </div>
      <div className="profile-mockup__body">
        <span className="tag tag--verified profile-mockup__verified">
          <Icon name="check" size={11} />
          GOMPA Verified
        </span>
        <h3 className="profile-mockup__name">{PROFILE.name}</h3>
        <div className="row profile-mockup__tags">
          <span className="tag">{PROFILE.traditionLabel}</span>
        </div>
        <p className="profile-mockup__meta">
          {PROFILE.offeringCount} offerings · {PROFILE.location}
        </p>
      </div>
    </div>
  );
}
